import type { IconSvgObject } from './types';

const CornerUpRightIcon: IconSvgObject = [
  ["path", { d: "M15 14.002L20 9.00195L15 4.00195M19 9.00195L7 9.00195C5.34315 9.00195 4 10.3451 4 12.002L4 20.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default CornerUpRightIcon;
